import { render, staticRenderFns } from "./AccountsPayable.vue?vue&type=template&id=663dea6e&"
import script from "./AccountsPayable.vue?vue&type=script&lang=ts&"
export * from "./AccountsPayable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports